import React, { Fragment } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Checkbox } from "components"
import classes from "./OrdersTableHeader.module.scss"

const OrdersTableHeader = (props) => {
  const { hideCheckBox = false, onSelectAll, allSelected } = props

  const [t, i18n] = useTranslation()

  const serviceTypeName =
    useSelector(state =>
      state.systemSettings.serviceTypeName
    )

  const isLtr = i18n.dir(i18n.language)

  return (
    <thead>
      <tr>
        <th
          className={clsx(
            classes["header-item1"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {
            !hideCheckBox &&
            <Checkbox
              checked={allSelected}
              onChange={onSelectAll}
            />
          }
        </th>
        <th
          className={clsx(
            classes["header-item2"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("کد")}
        </th>
        <th
          className={clsx(
            classes["header-item3"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("وضعیت")}
        </th>
        <th
          className={clsx(
            classes["header-item4"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("تاریخ_ثبت")}
        </th>
        <th
          className={clsx(
            classes["header-item5"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("نحوه_تحویل")}
        </th>
        <th
          className={clsx(
            classes["header-item5"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("طریق_سفارش")}
        </th>
        <th
          className={clsx(
            classes["header-item7"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("شعبه")}
        </th>
        {
          serviceTypeName === "restaurant" &&
          <Fragment>
            <th
              className={clsx(
                classes["header-item5"],
                isLtr && classes["header-item-ltr"]
              )}
            >
              {t("شماره_میز")}
            </th>

            <th
              className={clsx(
                classes["header-item5"],
                isLtr && classes["header-item-ltr"]
              )}
            >
              {t("سالن_سینما")}
            </th>
          </Fragment>
        }
        <th
          className={clsx(
            classes["header-item6"],
            isLtr && classes["header-item-ltr"]
          )}
        >
          {t("جزئیات")}
        </th>
      </tr>
    </thead>
  )
}

export default OrdersTableHeader